import { render } from "./EditOrdersModal.vue?vue&type=template&id=2fb9a1d2"
import script from "./EditOrdersModal.vue?vue&type=script&lang=js"
export * from "./EditOrdersModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__